"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M20.03 4.104l-7.107-2.45a2.844 2.844 0 00-1.85 0L3.97 4.105c-.582.203-.97.723-.97 1.304v8.341c0 3.26 3.193 5.713 6.662 8.044 1.397.94 3.279.94 4.68 0 3.469-2.328 6.662-4.784 6.662-8.044V5.408c-.004-.581-.392-1.101-.974-1.304zM10.197 15.9L7.41 13.28l1.272-1.196 1.515 1.425 5.121-4.814 1.272 1.196-6.393 6.01z" }), "Policies");
//# sourceMappingURL=Policies.js.map